import { render, staticRenderFns } from "./CampaignActionsButtons.vue?vue&type=template&id=8dd83aca&scoped=true&"
import script from "./CampaignActionsButtons.vue?vue&type=script&lang=js&"
export * from "./CampaignActionsButtons.vue?vue&type=script&lang=js&"
import style0 from "./CampaignActionsButtons.vue?vue&type=style&index=0&id=8dd83aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd83aca",
  null
  
)

export default component.exports